import { CLOUD_PROJECT_LIST, CLOUD_USER } from "../../features/cloudstorage/cloud";
import { requestProjectList } from "../../features/requests";
import { validateInput } from "../../features/validateinput";
import { getAppCfg } from "../app-cfg";
import { loadCurrentProjectList, loadProjectList } from "../code/loader";
import { CONSTANTS } from "../constants";
import { createCloudId, createTemplateProjectId, getProjectMetaFromCloudId, getTemplateProjectId, isCloudProjectId } from "../project/projectid";
import { getDomainCfg, getStateValue, setStateValue, store } from "../state";
import { AllowedProjectsList, ProjectListEntry } from "../types";

export const PROJECTS_LIST = "projectsList";

export const loadAllowedProjectLists = async (paths : string[]) => {
  const allowedProjectsList : AllowedProjectsList = {projects: []};
  for (let i = 0; i < paths.length; i++) {
    const path = paths[i];
    const data = await loadAllowedProjectList(path);
    allowedProjectsList.projects.push(...data.projects);
  }
  //console.log(`Loaded Projects from List: ${allowedProjectsList.projects.length}`);
  store.setState(PROJECTS_LIST, allowedProjectsList);
};

export async function loadAllowedProjectList(path : string) : Promise<AllowedProjectsList> {
  const data = await requestProjectList(path);
  return data;
}

export function getAllowedProjectsList() : AllowedProjectsList {
  const projectsListState = store.getState(PROJECTS_LIST);
  return projectsListState.getValue();
}

/*
 possible:

 BANA
 BANA_1
 user:BANA
 user:BANA_1

 BANA should be in projectDir

*/

export const getProjectFromDirectory = async (projectIdFromParam : string) : Promise<string | undefined> => {
  const idToCheck = projectIdFromParam;
  const isCloudProject = isCloudProjectId(idToCheck);

  if (isCloudProject) { // user:BANA or user:BANA_1
    const projectIdFromCloud = getProjectMetaFromCloudId(idToCheck);
    const userId : string = projectIdFromCloud.userId;
    const validUserName = validateInput(userId, CONSTANTS.USER_NAME_MIN, CONSTANTS.USER_NAME_MAX);
    if (validUserName === false) {
      return undefined;
    }

    const templateProject = getTemplateProjectId(projectIdFromCloud.projectId);
    if (templateProject.templateNumber > -1) { // user:BANA_1
      const projectDir = findProjectInAllowedProjectList(templateProject.projectId);
      if (projectDir) {
        const templateProjectId = createTemplateProjectId(projectDir.code, templateProject.templateNumber.toString());
        return await createCloudId(projectIdFromCloud.userId,templateProjectId);
      }
    } else { // user:BANA
      const projectDir = findProjectInAllowedProjectList(projectIdFromCloud.projectId);
      if (projectDir) {
        return await createCloudId(projectIdFromCloud.userId,projectDir.code);
      }
    }
  }

  const templateProject = getTemplateProjectId(idToCheck);
  if (templateProject.templateNumber > -1) { // BANA_1
    const projectDir = findProjectInAllowedProjectList(templateProject.projectId);
    if (projectDir) {
      return createTemplateProjectId(projectDir.code, templateProject.templateNumber.toString());
    }
  }

  const projectDir = findProjectInAllowedProjectList(idToCheck);
  if (projectDir) {
    return projectDir.code; // BANA
  }

  return undefined;
}

const findProjectInAllowedProjectList = (idToCheck : string) => {
  return getAllowedProjectsList().projects.find(projectEntry => projectEntry.code === idToCheck);
}

export const findProjectsWithCategory = (projectList : ProjectListEntry[], category : string) => {
  if (!category) return projectList;
  const filteredAllowedProjects = getAllowedProjectsList().projects.filter(projectEntry => projectEntry.catkey === category);
  
  const filteredProjectList = [];
  for (let i = 0; i < projectList.length; i++) {
    const project = projectList[i];
    const projectId = getTemplateProjectId(project.id).projectId;
    const projectEntry = filteredAllowedProjects.find(projectEntry => projectEntry.code === projectId);
    if (projectEntry) {
      filteredProjectList.push(project);
    }
  }
  return filteredProjectList;
}

export const findCategoriesFromProjects = () => {
  const categories : string[] = [];
  const allowedProjectsList = getAllowedProjectsList();
  for (let i = 0; i < allowedProjectsList.projects.length; i++) {
    const projectEntry = allowedProjectsList.projects[i];
    if (projectEntry.catkey && categories.indexOf(projectEntry.catkey) < 0) {
      categories.push(projectEntry.catkey);
    }
  }
  return categories;
}

export const findProjectsWithoutCategory = (projectList : ProjectListEntry[]) => {
  const filteredProjectList = [];
  for (let i = 0; i < projectList.length; i++) {
    const project = projectList[i];
    if (project.id) {
      const projectId = getTemplateProjectId(project.id).projectId;
      const projectEntry = getAllowedProjectsList().projects.find(projectEntry => projectEntry.code.toLocaleLowerCase() === projectId.toLocaleLowerCase() && projectEntry.catkey === undefined);
      if (projectEntry) {
        filteredProjectList.push(project);
      }
    }
  }
  return filteredProjectList;
}

export const getIconForProject = (projectId ? : string) => {
  const projectEntry = findProjectInAllowedProjectList(projectId ? projectId : getAppCfg().projectId);
  if (projectEntry && projectEntry.icon && projectEntry.icon.length > 0) {
    return getDomainCfg().projectSettings.iconPath + projectEntry.icon;
  }
  return "/assets/img/kiste.png";
}

export const getNewTemplateProjectId = async (templateProjectId) => {  
  await loadProjectList();
  const cloudList = getStateValue(CLOUD_PROJECT_LIST);
  const cloudUser = getStateValue(CLOUD_USER);
  const localProjectList = loadCurrentProjectList(cloudList, cloudUser);
  let currentNewProjectId = templateProjectId.toUpperCase();
  let newId = 1;
  let templateProjectIdExists = localProjectList.findIndex(project => project.id === templateProjectId);
  console.log('projectlist for new project', localProjectList, templateProjectIdExists);
  while (templateProjectIdExists > -1) {
    currentNewProjectId = templateProjectId + "_" + newId;
    templateProjectIdExists = localProjectList.findIndex(project => project.id === currentNewProjectId);
    if (templateProjectIdExists < 0) {
      return currentNewProjectId;
    } 
    newId++;
  }
  return currentNewProjectId;
}
